(function ($) {
  function isScrolledIntoView($elem, $window) {
    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();
    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();
    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  function mark(keyword,classTrigger) {
    // Determine selected options
    var options = {
      "each": function(element) {
        setTimeout(function() { jQuery(element).addClass("animate"); }, 500);
      }
    };
    options['separateWordSearch'] = false;
    options['element'] = 'marker';
    //console.log('mark keyword: ' + keyword);
    jQuery("."+classTrigger).mark(keyword, options);
  };

  var markKeyword=[];
  var markerClass = [];
  var i =0;
  jQuery(".has-inline-color").each(function(){
    markKeyword[i] = jQuery(this).text();
    jQuery(this).addClass("marker"+i);
    markerClass[i]= "marker"+i;
    i++;
  });
  //console.log( markKeyword );

  var keyword = markKeyword;
  var html_trigger = markerClass;
    jQuery(document).on("scroll", function () {
    var $window = jQuery(window);
    // Read the keyword
    jQuery.each(html_trigger, function(index, value){
      var elem = jQuery('.'+value);
      if (isScrolledIntoView(elem, $window)) {
        //console.log(keyword[index]);
        mark(keyword[index],html_trigger);
        if (index > -1) {
          keyword.splice(index, 1);
          html_trigger.splice(index, 1);
        }
      }
    });
  });
}) (jQuery);